import { useEffect, useState } from 'react'

export const useHeaderOffset = () => {
  const announcementBar = document.getElementById('shopify-section-announcement')
  const header = document.getElementById('shopify-section-header')
  if (!announcementBar || !header) return 0

  const [announcementBarHeight, setAnnouncementBarHeight] = useState(0)

  const calculateAnnouncementBarHeight = () => {
    const announcementBarOffsetHeight = announcementBar.offsetHeight - announcementBar.getBoundingClientRect().top * -1

    if (announcementBarOffsetHeight < 0) {
      setAnnouncementBarHeight(0)
      return
    }

    setAnnouncementBarHeight(announcementBarOffsetHeight)
  }

  useEffect(() => {
    calculateAnnouncementBarHeight()
    window.addEventListener('scroll', calculateAnnouncementBarHeight)

    return () => window.removeEventListener('scroll', calculateAnnouncementBarHeight)
  }, [])

  return announcementBarHeight + header.offsetHeight
}
